<template>
  <div>
    <div class="gradient">
      <div class="container">
        <div class="row" style="color: white">
          <div class="d-block d-sm-none col-12">
            <img src="../assets/page_cam_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
          <div class="col-12 col-lg-5" style="margin-top: auto; margin-bottom: auto">
            <h1 class="text-center">CAM</h1>
            <h2 class="text-center mb-4">Centro de Administración de líneas móviles.</h2>
            <p class="text-justify">
              Es un sistema de consulta auto-administrable que te
              ayudará a tener una visión más amplia y detallada de tu
              distribuidora de una manera sencilla y certera.
            </p>
            <p class="text-justify mb-5">
              Tu información siempre conectada y disponible en todo
              momento desde nuestra plataforma web o aplicación para
              dispositivos Android®
            </p>
          </div>
          <div class="col-7 d-none d-sm-block">
            <img src="../assets/page_cam_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5" style="position: relative; top:-15px">
        <div class="col-lg-3 col-hover px-0" v-for="card in cards">
          <div :style="`height: 30px; background-color: ${card.color}`"></div>
          <h3 class="text-center px-5 my-3" style="height: 65px;">{{card.titulo}}</h3>
          <p class="text-justify px-4">{{card.texto}}</p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-6">
          <div id="carousel-example-2" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
              <li data-target="#carousel-example-2" data-slide-to="1"></li>
              <li data-target="#carousel-example-2" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner" role="listbox">
              <div class="carousel-item active">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_cam_slider_01.png" height="200px"
                       alt="First slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_cam_slider_01.png" height="150px"
                       alt="First slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Disponible en Cam-App para Android</p>
                </div>
              </div>
              <div class="carousel-item">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_cam_slider_02.png" height="200px"
                       alt="Second slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_cam_slider_02.png" height="150px"
                       alt="Second slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Muestra de indicadores y KPI ́S graficamente</p>
                </div>
              </div>
              <div class="carousel-item">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_cam_slider_03.png" height="200px"
                       alt="Third slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_cam_slider_03.png" height="150px"
                       alt="Third slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Disponible para CAM Movistar</p>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-left fa-3x "></i></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-right fa-3x"></i></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6 px-5">
          <p>
            Calcula tus comisiones con un solo click
          </p>
          <p>
            Entérate que líneas no te están pagando en todos tus meses
            de comisionamiento.
          </p>
          <p>
            Visualiza y controla la calidad de tus socios comerciales,
            clientes, promotores, etc. conociendo el status de cada uno
            de sus ICC (inactivas, preactivas, activas, altas, exportadas).
          </p>
          <p>
            Conoce tu indicador N, N+1, N+2...hasta N+11 de cada uno de
            tus meses de activación.
          </p>
          <p>
            Y MÁS...TODO EN TIEMPO REAL DESDE LA PALMA DE TU
            MANO.
          </p>
        </div>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-8 col-lg-3">
          <a class=" btn  text-capitalize z-depth-0  py-1" style="color: white !important; background-color: #00A492 !important;" @click="to('Landing')" href="#contact">
            <p class="text-truncate ml-auto mr-auto my-1">Solicitar Demo</p>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Cam",
    data() {
      return {
        cards: [{
          color: `#00A492`,
          titulo: `Disponible`,
          texto: `Si eres distribuidor Movistar®
                   o At&t® /Unefon®, esta
                   solución es para ti.`
        }, {
          color: `#008DA3`,
          titulo: `Mide tus indicadores`,
          texto: `Conoce, mide y mejora tus
                 indicadores y KPI ́S gracias a
                 la información proporcionada
                 dentro del sistema.
                 Logra la calidad que tanto
                 deseas.`
        }, {
          color: `#0064A3`,
          titulo: `Haz rentable tu operación`,
          texto: `Conoce tus promedios de
                 recarga, comisión generada,
                 como distribuidor y por cada
                 unidad de negocio dentro de
                 tu operación(vendedores,
                 tiendas, socios comerciales,
                 lideres, etc...).`
        }, {
          color: `#2F395D`,
          titulo: `Mejora tu toma de decisiones`,
          texto: `El sistema CAM te aportará
                 información de valor para
                 conocer la calidad de tus
                 líneas, tendrás la oportunidad
                 de observar de manera
                 sencilla e intuitiva tus
                 indicadores y poder dirigir tus
                 esfuerzos donde deban ser
                 dirigidos.`
        }]
      }
    },
    methods:{
      to(route){
        this.$router.push({name:route})
      }
    }
  }
</script>

<style scoped>

  .gradient{
    background: rgba(47,57,93,1);
    background: -moz-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(47,57,93,1)), color-stop(100%, rgba(0,101,163,1)));
    background: -webkit-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -o-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -ms-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: linear-gradient(to right, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2f395d', endColorstr='#0065a3', GradientType=1 );
  }

  .col-hover:hover {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .7) !important;
  }


  li {
    color: #00A492;
    background-color: #00A492;
  }

  span {
    color: #00A492;
  }

  .carousel .carousel-indicators li {
    width: 2.3rem;
    height: .7rem;
    border-radius: .9rem;
  }

  .btn{
    background-color: white;
    border-radius:25px!important;
    width:100%!important;
  }
</style>
